<template>
  <div class="bom-page">

    <!-- Hero -->
    <div class="bom-hero" style="background: #E35B4B; position: relative; overflow: hidden;">
      <div class="d-flex align-items-center justify-content-center pt-3">
        <h1 class="text-uppercase display-header home-text mx-2 text-center" style="color:#fff;">Best of Madison 2026</h1>
      </div>

      <div class="d-flex align-items-center justify-content-center pt-2 pb-3">
        <span style="color:#231F20; font-size: 1.6rem; font-weight: 700; letter-spacing: 2px; text-transform: uppercase; text-align: center;">Vote Atlas Improv!</span>
      </div>

      <div class="d-flex align-items-center justify-content-center pt-2 pb-4 px-4">
        <div style="max-width: 800px; color:#fff; font-size: 1.1rem; line-height: 1.6; text-align: center;">
          <p>Atlas Improv Co. is the <strong>only improv group nominated in four categories</strong>.</p>
        </div>
      </div>

      <!-- Nominee image -->
      <div class="d-flex align-items-center justify-content-center pb-4 px-4">
        <a href="https://madisonmagazine.secondstreetapp.com/Best-of-Madison-2026/gallery/522536587" target="_blank" rel="noopener">
          <img :src="bomImg" alt="Atlas Improv Co. — Best of Madison 2026 nominee" class="bom-image" />
        </a>
      </div>

      <div class="d-flex align-items-center justify-content-center pt-3 pb-5 px-4">
        <p style="max-width: 800px; color:#fff; font-size: 1.5rem; line-height: 1.5; text-align: center; font-weight: 700; margin: 0;">Help Madison's only dedicated improv stage bring home the title(s)!</p>
      </div>
    </div>

    <div class="w-100 mb-3" style="height: 2px; background:#fff;"></div>

    <!-- Cast Your Votes -->
    <div class="d-flex align-items-center justify-content-center pt-5 pb-2">
      <h2 class="text-uppercase home-text text-center" style="color:#fff; font-size: 2.6rem;">Cast Your Votes</h2>
    </div>

    <div class="bom-cards">
      <a
        v-for="cat in categories"
        :key="cat.name"
        :href="cat.url"
        target="_blank"
        rel="noopener"
        class="bom-card"
        :style="{ borderColor: cat.color }"
      >
        <div class="bom-card-label" :style="{ color: cat.color }">{{ cat.name }}</div>
        <div class="btn text-uppercase bom-vote-btn" :style="{ backgroundColor: cat.color }">Vote Now</div>
      </a>
    </div>

    <!-- Free ticket incentive -->
    <div class="d-flex flex-column align-items-center justify-content-center pt-5 px-4 text-center">
      <div class="bom-freebie-label">Vote &amp; Get a Free Ticket</div>
      <p class="bom-freebie-text">Show us <strong>proof that you voted for Atlas</strong> in any one of these categories and we'll give you a <strong>free ticket</strong> to an Atlas show.</p>
    </div>

    <div class="pb-5"></div>

    <Footer />
  </div>
</template>

<script>
import Footer from '../components/Footer.vue';
import bomImg from '@/assets/BOM_IMG.jpeg';

export default {
  name: 'BOM',
  components: { Footer },
  data() {
    return {
      bomImg,
      categories: [
        {
          name: 'Comedy Group',
          url: 'https://madisonmagazine.secondstreetapp.com/Best-of-Madison-2026/gallery/522536587',
          color: '#E35B4B',
        },
        {
          name: 'Performing Arts Group',
          url: 'https://madisonmagazine.secondstreetapp.com/Best-of-Madison-2026/gallery/522632773/',
          color: '#39A5BF',
        },
        {
          name: 'Local Theater',
          url: 'https://madisonmagazine.secondstreetapp.com/Best-of-Madison-2026/gallery/522638483',
          color: '#BB4A8C',
        },
        {
          name: 'Best Place for a First Date',
          url: 'https://madisonmagazine.secondstreetapp.com/Best-of-Madison-2026/gallery/522632997/',
          color: '#138B4D',
        },
      ],
    };
  },
};
</script>

<style scoped>
.bom-page {
  min-height: 100vh;
  background: #231F20;
}

.bom-hero {
  position: relative;
  padding: 40px 20px;
}

.bom-image {
  width: 100%;
  max-width: 720px;
  height: auto;
  display: block;
  border-radius: 10px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.45);
}

.bom-freebie-label {
  font-family: 'Oswald', sans-serif;
  font-size: 1.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 3px;
  color: var(--atlas-yellow);
  margin-bottom: 1rem;
}

.bom-freebie-text {
  max-width: 760px;
  color: #fff;
  font-size: 1.15rem;
  line-height: 1.6;
  margin: 0;
}

.bom-cards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;
  max-width: 900px;
  margin: 1rem auto 0;
  padding: 0 1.5rem;
}

.bom-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
  background: #2C2728;
  border: 2px solid;
  border-radius: 12px;
  padding: 2.25rem 1.5rem;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.bom-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.45);
}

.bom-card-label {
  font-family: 'Oswald', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-align: center;
  line-height: 1.25;
}

.bom-vote-btn {
  color: #fff !important;
  min-width: 160px;
  font-weight: 700;
  letter-spacing: 1px;
}

@media (max-width: 600px) {
  .bom-cards {
    grid-template-columns: 1fr;
  }

  .bom-image {
    max-width: 100%;
  }

  .display-header.text-uppercase {
    font-size: 3rem !important;
  }
}
</style>
